import axios from "axios";
import toast from "react-hot-toast";
import { getUserProfil, HOME, resetStorage, userToken } from "../Utils/Utils";
import { BASE_URL, ERROR_MESSAGE_TOKEN_EXPIRE } from "../Utils/constant";
import { logout } from "./service";

// Configuration de l'instance Axios
const clientAxios = axios.create({
  baseURL: BASE_URL
});

// Génération d'un nonce unique
const generateNonce = () => {
  return `${Date.now().toString(36)}${Math.random().toString(36).substring(2)}`;
};

// Gestion de la déconnexion
const handleLogout = async () => {
  const infoUser = getUserProfil();
  try {
    if (infoUser?.username) {
      await logout(infoUser.username);
    }
  } catch (error) {
    console.error("Erreur lors de la déconnexion:", error);
  } finally {
    resetStorage();
    window.location.replace(`#${HOME}/login`);
  }
};

// Intercepteur de requête
clientAxios.interceptors.request.use(
  (config) => {
    const token = userToken();

    // Ajout des headers de sécurité
    config.headers["X-Nonce"] = generateNonce();
    config.headers["X-Timestamp"] = new Date().toISOString();

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Erreur dans l'intercepteur de requête:", error);
    return Promise.reject(error);
  }
);

// Intercepteur de réponse
clientAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Erreur de réseau
    if (error.code === "ERR_NETWORK") {
      toast.error("Oops! Problème de connexion au serveur.");
      return Promise.reject(error);
    }

    // Pas de réponse du serveur
    if (!error.response) {
      toast.error("Impossible de contacter le serveur.");
      return Promise.reject(error);
    }

    const { status, data } = error.response;
    const token = userToken();

    // Gestion des erreurs par code de statut
    switch (status) {
      case 401:
        // Token expiré ou invalide
        if (token || data?.donnee === ERROR_MESSAGE_TOKEN_EXPIRE) {
          toast.error("Votre session a expiré. Veuillez vous reconnecter.");
          await handleLogout();
        } else {
          toast.error("Vous n'êtes pas authentifié.");
        }
        break;

      case 403:
        toast.error("Changement de mot de passe initial requis.");
        window.location.replace(`#${HOME}/profil`);
        break;

      case 500:
      case 502:
      case 503:
        toast.error("Erreur serveur. Veuillez réessayer plus tard.");
        break;

    }

    return Promise.reject(error);
  }
);

export default clientAxios;